import './index.scss'
import { axios as $http } from 'cm'
import api from './api'
import qs from 'qs'
import Bridge from '../../../frontend-lib/lib/Bridge'
import Comment from '../../../public-resource/components/Commnet/index'
import Swiper from 'swiper'
import {
  linebreakReplace,
  getPlatform,
  GetRequest,
  throttle
} from '../../../public-resource/libs/utils/index'

import { getRequestSign } from '../../../frontend-lib/tools/platformSign'
import { wxConfigOrigin } from 'src/frontend-lib/tools/utils'
import { getEnvHost } from 'src/frontend-lib/tools/getPlatform'

import renderQuestionList from './render/questionList'
import renderRankList from './render/rankList'
import rendRopicList from './render/topicList'
import './render/asideToolsButton'

import monitor from 'src/frontend-lib/lib/monitor'

// import vconsole from 'vconsole'
// new vconsole()

// 导入富文本CSS
$('head').append(
  '<link rel="stylesheet" href="https://static.xinli001.com/fe-app/style/theme-yixinli.css">'
)
;(function() {
  let qa = qa || {}

  const COMMENT = new Comment()
  const PROTOCOL = window.location.protocol

  let UAobj = getPlatform()
  let token = ''
  let userInfo = {}
  let UA = window.navigator.userAgent.toUpperCase() // 环境
  let IS_APP = UA.toLocaleLowerCase().indexOf('yixinliapp') > -1
  let IS_WX = UA.toUpperCase().indexOf('MICROMESSENGER') > -1
  let myBridge = new Bridge()
  let isFeel = false // 控制同感
  let urlparams = GetRequest()
  let branchId = +urlparams.cantonal_id || 0 // 分馆id
  let unionid = urlparams.union_id || ''
  let openid = urlparams.open_id || ''
  let branchName = window.baseInfo.cantonal_name
  let isMaster = +window.baseInfo.is_master
  let isjoin = +window.baseInfo.is_already_join
  let placardUrl = '' // 海报地址
  let sshzv = 0
  if (urlparams.sshzv == 1) {
    sshzv = 1 // 审核中
  }

  window.baseInfo.wx_share.url = window.baseInfo.wx_share.url.replace(
    window.location.protocol + getEnvHost(`//m.xinli001.com`),
    wxConfigOrigin(require('../../../../yxlConfig.json'), 'QA_ORIGIN', 'm_safe')
  )

  if (IS_APP) {
    $('.container').css('padding-top', 0)
    myBridge.call('getToken', { callbackName: 'loginOperation' })
    myBridge.call('setConfig', { isAllowedTitleAnimate: 1 })
    myBridge.call('setTitle', {
      title: `人生答疑馆·${branchName}`
    })

    myBridge.MethodCall({
      method: 'topFuncBtn',
      callback: ops => {
        if (ops.name === 'shareReportBtn') {
          myBridge.call('shareReport', {
            link: window.baseInfo.wx_share.url,
            imgUrl: window.baseInfo.wx_share.image,
            desc: window.baseInfo.wx_share.desc,
            title: window.baseInfo.wx_share.title
          })
        }
      }
    })
    myBridge.call('topFuncBtnConfig', {
      btnList: [
        {
          name: 'shareReportBtn',
          visible: 1
        }
      ]
    })

    $('.branch-down').toggle()
  } else {
    $('.nav-header').css('display', 'block')
  }

  if (IS_WX) {
    $('.nav-title').text('这里是我们的安全屋')
  }

  // window.yxl.stat.send({
  //   name: '问答-「主页」访问'
  // })

  let body = document.querySelector('body')
  // body.addEventListener("click", function(e) {});
  body.addEventListener('touchend', function(e) {})

  $('#topic li').on('click', function() {
    let topicId = $(this).data('topicid')
    // 埋点
    window.yxl.stat.send({
      name: '问答-交互行为',
      properties: {
        页面: '分馆首页',
        行为: '点击',
        对象: `话题入口`,
        topicId
      }
    })
  })

  // IOS 微信浏览器开启点击事件
  $('body>*').bind('click', function() {})

  var loadingDiv =
    '<div class="loadingDiv"><div class="mint-indicator-wrapper" style="padding: 15px;"><span class="mint-indicator-spin"><div class="mint-spinner-snake" style="border-top-color: rgb(204, 204, 204); border-left-color: rgb(204, 204, 204); border-bottom-color: rgb(204, 204, 204); height: 32px; width: 32px;"></div></span> <span class="mint-indicator-text" style="display: none;"></span></div></div>'
  $('body').append(loadingDiv)

  const lastReplayInfo = {
    replayEle: null,
    lastReplayId: null,
    answerId: null,
    replayNum: 0,
    content: null
  }

  function reply() {
    let $config = {
      title: '回复',
      placeholder:
        '一个感同身受的回应，有效的解决问题的方法，都是对提问者有用的回答',
      callback(content) {
        if (IS_APP) {
          myBridge.call('switchTitleBar', {
            isHidden: 0
          })
          myBridge.call('isPullRefreshEnable', {
            enable: 1
          })
          myBridge.call('setConfig', { isAllowedTitleAnimate: 1 })
        }
        if (content) {
          lastReplayInfo.content = content
          window.replayOperation(content)
        }
      },
      max: 5000,
      skipApp: true,

      backFn: function() {
        if (IS_APP) {
          myBridge.call('switchTitleBar', {
            isHidden: 0
          })
          myBridge.call('isPullRefreshEnable', {
            enable: 1
          })
          myBridge.call('setConfig', { isAllowedTitleAnimate: 1 })
        }
      }
    }

    if (IS_APP) {
      myBridge.call('switchTitleBar', {
        isHidden: 1
      })
      myBridge.call('isPullRefreshEnable', {
        enable: 0
      })
      myBridge.call('setConfig', { isAllowedTitleAnimate: 0 })
    }

    COMMENT.show($config)
  }

  let timeOutEvent
  let longClick = false
  // $('.branchPlacard').on('touchstart', function() {
  //   longClick = false
  //   clearTimeout(timeOutEvent)
  //   timeOutEvent = setTimeout(function() {
  //     longClick = true
  //   }, 500)
  // })
  // $('.branchPlacard').on('touchend', function() {
  //   clearTimeout(timeOutEvent)
  //   if (!longClick) {
  //     $('.branchPlacard').toggle()
  //   }
  //   return false
  // })
  $(document).delegate('.branchPlacard', 'touchstart', function() {
    longClick = false
    clearTimeout(timeOutEvent)
    timeOutEvent = setTimeout(function() {
      longClick = true
    }, 500)
  })
  $(document).delegate('.branchPlacard', 'touchmove', function() {
    clearTimeout(timeOutEvent)
    longClick = true
    // return false
  })
  $(document).delegate('.branchPlacard', 'touchend', function() {
    clearTimeout(timeOutEvent)
    if (!longClick) {
      branchPlacardToggle()
    }
    return false
  })

  $(document).delegate('.closeBranchPlacard', 'click', function() {
    branchPlacardToggle()
  })

  function branchPlacardToggle(isFirst = false) {
    $('body').toggleClass('fixPlacard')

    if (!isFirst) {
      $('.branchPlacard').toggle()
    }
  }

  function showPlacard() {
    if (!IS_WX) return
    if (placardUrl) {
      branchPlacardToggle()
    } else {
      let placardParams = window.baseInfo.placard
      // placardParams = {
      //   unionid: 'o46ZF0yH3sPHWY-LyUS3-TH0mgNs',
      //   nickname: '🍒etseleC',
      //   headimg: 'http://thirdwx.qlogo.cn/mmopen/vi_32/0LEArUcmuzibsNglJuG3xb0jbJjf1v7WNiaia0KicCicWzibEhTomgLK92mBBUZCtM9TFvUuzn58fkNyicL4Hra2toPyg/132'
      // }
      $http
        .post(
          api.showPlacard,
          qs.stringify({
            pid: 248,
            ...placardParams,
            fenguanId: branchId,
            fenguanName: branchName
          })
        )
        .then(({ data: res }) => {
          if (+res.errcode === 0) {
            placardUrl = res.data
            $('body').append(`
              <div class="branchPlacard">
                <div class="branchPlacardHeader">
                  <div class="closeBranchPlacard">返回</div>
                  <div class="branchPlacardTitle">长按保存海报</div>
                </div>
                <div class="branchPlacardContent">
                  <img src="${placardUrl}" alt="分馆海报">
                </div>
              </div>
            `)
            branchPlacardToggle(true)
          } else {
            window.toast(res.errmsg)
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  function goTopicRewardArticle() {
    directTo('https://www.xinli001.com/info/100462419')
  }

  function showReceiveRewardDialog($this) {
    if ($this.attr('hasReceive')) {
      goTopicRewardArticle()
      return
    }
    let $el = $('.receiveReward')
    if ($el[0]) {
      $el.toggle()
    } else {
      $('body').append(`
        <div class="receiveReward">
          <div class="wrap">
            <p class="text">恭喜完成一次有奖书写计划/故事集，点击获得奖励，领取后立即生效。</p>
            <div class="operation">
              <span class="cancel">取消</span>
              <span class="confirm">确认领取</span>
            </div>
          </div>
        </div>
      `)
      $('.receiveReward .confirm').on('click', function() {
        let $li = $this.parents('li')
        $http
          .post(api.writingPlanAward, {
            topic_id: $li.attr('topicId'),
            award_id: $li.attr('awardId'),
            token
          })
          .then(({ data: res }) => {
            if (+res.code === 0) {
              // $this.attr('hasReceive', true)
              // $('.receiveReward').toggle()
              goTopicRewardArticle()
            } else {
              window.toast(res.message)
            }
          })
      })
      $('.receiveReward .cancel').on('click', function() {
        $('.receiveReward').toggle()
      })
    }
  }

  function showLeaveBranchDialog() {
    let $el = $('.leaveBranch')
    if ($el[0]) {
      $el.toggle()
    } else {
      $('body').append(`
        <div class="leaveBranch">
          <div class="wrap">
            <p class="text">在${branchName}分馆的互助分、补贴会清零，确认退出该分馆吗？</p>
            <div class="operation">
              <span class="confirm">确认</span>
              <span class="cancel">取消</span>
            </div>
          </div>
        </div>
      `)
      $('.leaveBranch .confirm').on('click', function() {
        $http
          .post(api.leaveBranch, {
            cantonal_id: branchId,
            token
          })
          .then(({ data: res }) => {
            if (+res.code === 0) {
              window.location.reload()
            } else {
              window.toast(res.message)
            }
          })
      })
      $('.leaveBranch .cancel').on('click', function() {
        $('.leaveBranch').toggle()
      })
    }
  }

  function joinBranch({ ele, type }) {
    if (!loginJudment(false)) return

    let currJoinBtn
    if (type === 'slide') {
      currJoinBtn = ele.children('.join-branch')
    } else if (type === 'float') {
      currJoinBtn = ele
    }
    if (currJoinBtn.attr('hasJoin') === 'true') return

    $http
      .post(api.joinBranch, {
        cantonal_id: branchId,
        union_id: unionid,
        open_id: openid,
        token
      })
      .then(({ data: res }) => {
        if (+res.code === 0) {
          window.toast('加入分馆成功')
          currJoinBtn.attr('hasJoin', true)
          if (type === 'slide') {
            currJoinBtn.text('已加入')
            let otherJoinBtn = ele.siblings().children('.join-branch')
            otherJoinBtn.attr('hasJoin', true)
            otherJoinBtn.text('已加入')
          } else if (type === 'float') {
            currJoinBtn.text('保存本馆海报')
          }
        } else {
          window.toast(res.message)
        }
      })
  }

  function carousel() {
    let $carousel = $('#carousel')
    let rollList = window.baseInfo.roll_list
    let rollListTemp = []
    try {
      rollList = JSON.parse(rollList)
    } catch (e) {
      rollList = []
    }
    if (rollList.length) {
      let validItem = 0
      let tpl = '<div class="swiper-wrapper">'
      rollList.forEach(item => {
        let type = +item.type
        let content = item.content

        if (content) {
          ++validItem
        } else {
          return
        }
        rollListTemp.push(item)

        if (type === 11) {
          tpl += `<div class="swiper-slide">
                    <div class="branch-msg">
                      ${content}
                    </div>
                    <div class="yxlicon icon-iconfonti"></div>
                  </div>`
        } else if (type === 10) {
          tpl += `<div class="swiper-slide">
                    <div class="branch-msg">
                      ${content}
                    </div>
                    <div class="btn join-branch">加入分馆</div>
                  </div>`
        } else {
          tpl += `<div class="swiper-slide">
                    <div class="branch-msg">
                      ${content}
                    </div>
                    <div class="btn branch-invite">了解互助分</div>
                  </div>`
        }
      })

      if (!validItem) {
        $carousel.height(0)
        tpl = ''
        return
      }
      rollList = rollListTemp

      tpl += '</div>'
      $carousel.html(tpl)

      $(document).delegate('.swiper-slide', 'click', function() {
        let $this = $(this)
        let index = $this.attr('data-swiper-slide-index')
        let rollItem = rollList[index]
        let rollType = +rollItem.type
        let rollUrl = rollItem.redirect
        switch (rollType) {
          case 11:
            if (rollUrl) {
              if (IS_APP) {
                myBridge.call('openWebView', {
                  url: rollUrl,
                  isCurrentPageOpen: 0
                })
              } else {
                window.open(rollUrl)
              }
            }
            break
          case 10:
            joinBranch({ ele: $this, type: 'slide' })
            showPlacard()
            break
          default:
            let url = 'https://www.xinli001.com/info/100455627'
            if (IS_APP) {
              myBridge.call('openWebView', {
                url: url,
                isCurrentPageOpen: 0
              })
            } else {
              window.open(url)
            }
            break
        }
      })

      new Swiper('#carousel', {
        direction: 'vertical',
        autoplay: 5000,
        loop: true,
        autoplayDisableOnInteraction: false
      })
    } else {
      $carousel.height(0)
    }
  }

  function placard() {
    let tpl = '<div class="branch-info-toggle">'
    if (IS_APP && isMaster) {
      tpl += '<span class="branch-admin">管理</span>'
    }
    if (IS_WX) {
      tpl += '<span class="branch-poster">分馆海报</span>'
    }
    // tpl += '<span class="branch-poster">分馆海报</span>'
    tpl += '<span class="branch-desktop">发送到桌面</span>'
    if (!IS_APP) {
      tpl += '<span class="branch-down">下载app</span>'
    }
    tpl += '<span class="branch-follow">关注公众号</span>'
    if (isjoin) {
      tpl += '<span class="branch-leave">退出分馆</span>'
    }
    tpl += '</div>'
    $('.branch-info-more').append(tpl)
  }

  function branchFloatToggle(isFirst = false) {
    if (isFirst) {
      const HAS_ENTER_BRANCH_list = 'has_enter_branch_list'
      let list = localStorage.getItem(HAS_ENTER_BRANCH_list) || '{}'
      list = JSON.parse(list)
      let hasEnterBranch = list[`id_${branchId}`]
      if (hasEnterBranch) return
      list[`id_${branchId}`] = 1
      localStorage.setItem(HAS_ENTER_BRANCH_list, JSON.stringify(list))
    }
    $('.branch-float').toggleClass('hidden')
  }

  function directTo(url, replace = 1) {
    if (IS_APP) {
      myBridge.call('openWebView', {
        url: url,
        isCurrentPageOpen: replace
      })
    } else {
      if (replace) {
        window.location.href = url
      } else {
        window.open(url)
      }
    }
  }

  function masterRemind() {
    if (isMaster) {
      let score = +window.baseInfo.cantonal_score || 0
      let lastscore = +window.localStorage.last_master_remind_score || 0
      let showMasterRemind = false
      if (score >= 2000 && lastscore < 2000) {
        showMasterRemind = true
      } else if (score >= 1000 && lastscore < 1000) {
        showMasterRemind = true
      } else if (score >= 300 && lastscore < 300) {
        showMasterRemind = true
      } else if (score >= 100 && lastscore < 100) {
        showMasterRemind = true
      }
      if (!showMasterRemind) return
      window.localStorage.last_master_remind_score = score

      $('body').append(`
        <div class="masterRemindToast">
          <div class="wrap">
            <div class="content">
              <p class="title">馆长提醒</p>
              <p class="desc">恭喜互助分达到<span>${score}</span>分，点击领取推广资源</p>
              <div class="btn">点击提交资料</div>
            </div>
            <div class="closeBtn yxlicon icon-guanbi"></div>
          </div>
        </div>
      `)
      $('.masterRemindToast .closeBtn').on('click', function() {
        $(this)
          .parents('.masterRemindToast')
          .hide()
      })
      $('.masterRemindToast .btn').on('click', function() {
        directTo('http://xinli001.mikecrm.com/XHUvMhL', 0)
      })
    }
  }

  // 回复操作
  window.replayOperation = function(content) {
    $('.loadingDiv').hide()
    $('.loadingDiv').show()
    let e = lastReplayInfo.replayEle
    let _content = encodeURIComponent(linebreakReplace(content))

    if (IS_APP) {
      myBridge.call('switchTitleBar', { isHidden: 0 })
      myBridge.call('isPullRefreshEnable', { enable: 1 })
      myBridge.call('setConfig', { isAllowedTitleAnimate: 1 })
    }
    $http
      .post(
        api.answerReplay,
        {
          answer_id: lastReplayInfo.answerId,
          content: _content,
          reply_user_id: lastReplayInfo.lastReplayId,
          token
        },
        { timeout: 20000, disabledUnLoginInterceptors: true }
      )
      .then(
        res => {
          $('.loadingDiv').hide()
          let _res = res.data
          let _code = +_res.code
          if (_code === 0) {
            window.localStorage.removeItem('reply_content')
            // app下关闭回复框
            let template = ''
            if (_res.data.reply_user_id !== 0) {
              template = `<div class="main-content">
                    <span class="name" data-user-id=${_res.data.user_id}>${
                _res.data.user_name
              }</span>
                    <span>回复</span>
                    <span class="name" data-user-id=${
                      _res.data.reply_user_id
                    }>${_res.data.reply_user_name}：</span>
                    <span class="content-detail"> ${decodeURIComponent(
                      _res.data.content
                    )}</span>
                    <span class="content-reply">回复</span>
                </div>`
            } else {
              template = `<div class="main-content">
                    <span class="name" data-user-id=${_res.data.user_id}>${
                _res.data.user_name
              }：</span>
                    <span class="content-detail"> ${decodeURIComponent(
                      _res.data.content
                    )}</span>
                    <span class="content-reply">回复</span>
                </div>`
            }

            e.parent('.input-comment').before(template)
            e.parents('.comment-content')
              .siblings('.ask-btn')
              .children('.ask-btn-comment')
              .children('.number')
              .children('span')
              .text(lastReplayInfo.replayNum + 1)
            window.toast('评论成功')
            window.yxl.stat.send({
              name: '问答-主页「回答内容操作事件合集」点击',
              properties: {
                操作分类: '评论提交'
              }
            })
          } else if (_code === 40002) {
            window.toast(res.data.message)
            window.sessionStorage.setItem('answer_area_content', content)
          } else if (_code === 40003) {
            window.toast(
              '您的账号违规已禁止发布问答，申诉请联系答疑馆-喵酱（微信号：dolphin_xinli001）~喵~'
            )
          } else {
            window.sessionStorage.setItem('answer_area_content', content)
          }
          e.attr('replayId', null)
          e.attr('placeholder', '回复评论')
        },
        err => {
          $('.loadingDiv').hide()
          // window.toast('评论失败，您输入的内容还会保留，请重新编辑提交');
          window.sessionStorage.setItem('answer_area_content', content)
        }
      )
  }

  function toLogin() {
    window.toast('检测到暂未登录,即将跳转到登录页面~')
    window.location.href = api.login
  }

  // app登录处理
  window.loginOperation = function(tokenObj) {
    let result = JSON.parse(tokenObj)
    if (typeof result.token === 'undefined' || result.token === '') {
      // toLogin()
      console.log(
        '校企渠道进行分馆合作洽谈时，由于访问分馆需要登录，于渠道用户而言体验较差'
      )
    } else {
      token = result.token
      loginJudment(true)
    }
  }

  function loginJudment(isFirstLoading) {
    if (isFirstLoading) {
      $http
        .get(api.isLogin)
        .then(res => {
          if (
            res.data.data.user &&
            typeof res.data.data.user.length === 'undefined'
          ) {
            userInfo = res.data.data.user
            token = userInfo.token
          }
        })
        .catch(err => {
          // window.toast(err)
          monitor.stat({
            level: 'error',
            error: 'api-data',
            msg: err,
            api: api.isLogin
          })
        })
    } else {
      if (token === '') {
        toLogin()
      } else {
        return true
      }
    }
  }
  if (!IS_APP) {
    loginJudment(true)
  }

  qa = (function() {
    let page = 1
    let loading = false // 是否加载数据
    let newques_tab_num = $('.child_tab button.active').index()

    let bindEvent = function() {
      // 还能邀答
      $(document).delegate('.ques-btn-invite', 'click', function(e) {
        e.preventDefault()

        window.yxl.stat.send({
          name: '问答-主页「回答内容操作事件合集」点击',
          properties: {
            操作分类: '邀答'
          }
        })

        let num = $(this)
          .find('.time')
          .text()
        if (+num === 0) {
          window.toast('分享问题给好友，每天可以增加邀答1次。')
          return
        }

        if (!loginJudment(false)) return

        let href =
          PROTOCOL +
          api.inviteList +
          '?ask_id=' +
          $(this).attr('data-question_id')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.location.href = href
        }
      })

      // 写个回答
      $(document).delegate('.ques-btn-answer', 'click', function(event) {
        event.preventDefault()
        let href = $(this)
          .children('a')
          .attr('href')
        href = href + '?cantonal_id=' + branchId
        directTo(href, 0)
      })

      // 有同感
      $(document).delegate('.ques-btn-feel', 'click', function(event) {
        if (!loginJudment(false)) return
        if (isFeel) {
          return
        }
        // console.log($(this).attr('data-question_id'));
        let id = $(this).attr('data-question_id')
        isFeel = true
        $http
          .get(api.sameFeel + '?question_id=' + id)
          .then(res => {
            // console.log(res)
            let ele = $(this)
              .children('p')
              .children('.number')
            let feelNumber = ele.text()
            let isHasFeel = $(this)
              .children('p')
              .hasClass('has-feel')
            if (isHasFeel) {
              if (!feelNumber.includes('w') && !feelNumber.includes('k')) {
                ele.text(parseInt(feelNumber) - 1)
              }
              $(this)
                .children('p')
                .removeClass('has-feel')
            } else {
              if (!feelNumber.includes('w') && !feelNumber.includes('k')) {
                ele.text(parseInt(feelNumber) + 1)
              }
              $(this)
                .children('p')
                .addClass('has-feel')
            }
            if (res.data.data.is_same_feeling === 1) {
              window.yxl.stat.send({
                name: '问答-主页「回答内容操作事件合集」点击',
                properties: {
                  操作分类: '有同感'
                }
              })
            }
            isFeel = false
            // window.toast(res.data.message)
          })
          .catch(err => {
            // window.toast(err)
            isFeel = false
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: api.sameFeel + '?question_id=' + id
            })
          })
      })

      // 关注
      $(document).delegate('.rank-attention', 'click', function() {
        if (!loginJudment(false)) return
        let id = $(this).attr('data-user-id')
        let url
        if (IS_APP && token) {
          url = api.followAttention + '?user_id=' + id + '&token=' + token
        } else {
          url = api.followAttention + '?user_id=' + id
        }
        $http
          .get(url, {
            disabledUnLoginInterceptors: true
          })
          .then(res => {
            if (res.data.code === 40002) {
              window.toast(res.data.message)
              return
            }
            if (res.data.code === 1) {
              window.toast(res.data.message)
              return
            }
            if (res.data.code === 0) {
              window.toast(res.data.message)
              $(this)
                .children('p')
                .toggle()
              if (res.data.data.is_follow === 1) {
                window.yxl.stat.send({
                  name: '问答-交互行为',
                  properties: {
                    页面: '分馆榜单',
                    行为: '点击',
                    对象: '关注',
                    咨询师: $(this)
                      .parents('.rank-item')
                      .attr('data-teacher'),
                    id
                  }
                })
              }
            }
          })
          .catch(err => {
            // window.toast(err)
            console.error(err)
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: url,
              apiParams: JSON.stringify({
                disabledUnLoginInterceptors: true
              })
            })
          })
      })

      $('.rank_list_ul').on('click', '.rank-avatar, .rank-info-name', function(
        e
      ) {
        e.preventDefault()

        let href =
          $(this).attr('href') ||
          $(this)
            .children('a')
            .attr('href')
        if (href === 'javascript:;' || !href) return

        window.yxl.stat.send({
          name: '问答-交互行为',
          properties: {
            页面: '分馆榜单',
            行为: '点击',
            对象: '用户头像',
            咨询师: $(this)
              .parents('.rank-item')
              .attr('data-teacher'),
            id: $(this)
              .parents('.rank-item')
              .attr('data-user-id')
          }
        })

        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(href)
        }
      })

      // 全文
      $(document).delegate('.switch', 'click', function(event) {
        event.preventDefault()
        $(this)
          .siblings('a')
          .children('.ask-detail')
          .removeClass('hide-content')
        $(this).css('display', 'none')
        $(this)
          .siblings('.arrow')
          .css('display', 'block')
      })

      // 收起
      $(document).delegate('.arrow', 'click', function(event) {
        event.preventDefault()
        $(this)
          .siblings('a')
          .children('.ask-detail')
          .addClass('hide-content')
        $(this).css('display', 'none')
        $(this)
          .siblings('.switch')
          .css('display', 'block')
      })
    }

    // 是否显示全文
    function showSwithFn() {
      let curList = $(`.newques_ul ul:eq(${newques_tab_num}) .ask-detail`)
      curList &&
        curList.each(function(index, e) {
          // console.log($(e).height())
          // console.log($(e)[0].scrollHeight)
          if ($(e).height() < $(e)[0].scrollHeight) {
            $(e)
              .parent()
              .siblings('.switch')
              .css('display', 'block')
          } else {
            $(e)
              .parent()
              .siblings('.switch')
              .css('display', 'none')
          }
        })

      if (newques_tab_num === 0) {
        $('.topicItem').each((index, e) => {
          let el = $(e).find('.content')[0]
          if (el.scrollHeight > $(el).height()) {
            $($(e).find('.showAll')[0]).show()
          }
        })
      }
    }

    let scroll = throttle(function() {
      let scrollH = document.documentElement.scrollHeight

      let clientH = document.documentElement.clientHeight

      let h = document.documentElement.offsetHeight
      let rect = document.documentElement.getBoundingClientRect()

      let min = 60

      if (
        rect.top <= 0 &&
        h - (Math.abs(rect.top) + window.innerHeight) <= min
      ) {
        console.log('scroll 111')
        $('.branch-title').trigger('click')
      }
    }, 1000)

    // 初始化加载数据和共通操作
    qa.init = function() {
      bindEvent()

      function renderTopAd(ads) {
        let recommendList = window.baseInfo.recommend_list
        try {
          recommendList = JSON.parse(recommendList)
        } catch (e) {
          recommendList = []
        }

        let matrixAd = []
        for (let i = 0; i < 5; i++) {
          let currentAd = recommendList[i]
          if (currentAd && currentAd.big_title) {
            let recommendAd = {}
            recommendAd.title = currentAd.big_title
            recommendAd.title2 = currentAd.little_title
            recommendAd.url = currentAd.redirect
            recommendAd.image =
              'https://ossimg.xinli001.com/20200108/fe25cec4e2b9b985f54512e5fe91a4a6.png?x-oss-process=image/quality,Q_80'
            matrixAd.push(recommendAd)
          } else {
            let ad = ads[i]
            if (ad) {
              matrixAd.push(ad)
            }
          }
        }

        let $template = ''
        matrixAd.forEach(adItem => {
          $template += `<div class="nav-content">
                          <a href="${adItem.url}" target="_blank" title=${
            adItem.title
          }>
                            <div class="img-content" keydesc="${
                              adItem.title
                            }" style="background-image: url(${adItem.image})">
                              <p class="title">${adItem.title}</p>
                              ${
                                adItem.title2
                                  ? `<p class="title smallTitle">${adItem.title2}</p>`
                                  : ''
                              }
                          </div>
                        </a>
                      </div>`
        })
        $('#nav-navigation').append($template)
      }

      // 头部广告
      function topADfn() {
        // 获取广告
        let params = {
          name: 'qa-branch-main', // 广告位名称 例如: index_banner
          size: '5', // 广告数量，默认5
          _version: UAobj.yixinliAPPVersion || '5.3.8', // App版本号
          // channel: '', // App渠道
          _platform: 'ios' // 平台，ios或android 默认值: ios
        }
        window.URLSearchParams = URLSearchParams
        const URLParams = new URLSearchParams(window.location.search)
        let _token = URLParams.get('token')
        if (_token) {
          params.token = _token
        }
        let platFormSign = getRequestSign(params)
        let newParams = Object.assign(platFormSign.params, {
          sign: platFormSign.sign
        })
        $http
          .get(api.getADList, {
            params: newParams
          })
          .then(res => res.data)
          .then(res => {
            let ads = []
            if (res.code === 0 && res.data.length > 0) {
              ads = res.data
            }
            renderTopAd(ads)
          })
          .catch(err => {
            console.error(err)
            renderTopAd([])
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: api.getADList,
              apiParams: JSON.stringify(newParams)
            })
          })
      }

      topADfn()

      // 轮播
      carousel()

      // 更多...
      placard()

      branchFloatToggle(true)

      masterRemind()

      // 微信分享
      if (IS_WX) {
        let currentUrl = document.location.href
        let getWxConfig = api.getWXShareConfig
        let shareInfo = window.baseInfo.wx_share
        $http
          .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
          .then(res => {
            if (res.data.code == 0) {
              var wxConfig = res.data.data

              function loadScript(url, callback) {
                var script = document.createElement('script')
                script.type = 'text/javascript'
                if (typeof callback !== 'undefined') {
                  if (script.readyState) {
                    script.onreadystatechange = function() {
                      if (
                        script.readyState == 'loaded' ||
                        script.readyState == 'complete'
                      ) {
                        script.onreadystatechange = null
                        callback()
                      }
                    }
                  } else {
                    script.onload = function() {
                      callback()
                    }
                  }
                }
                script.src = url
                document.body.appendChild(script)
              }

              setTimeout(() => {
                loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
                  var _config = {
                    debug: wxConfig.debug,
                    appId: wxConfig.appId,
                    timestamp: wxConfig.timestamp,
                    nonceStr: wxConfig.nonceStr,
                    signature: wxConfig.signature,
                    jsApiList: [
                      'onMenuShareTimeline',
                      'onMenuShareAppMessage',
                      'onMenuShareQQ',
                      'onMenuShareWeibo',
                      'onMenuShareQZone',
                      'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                      'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                  }

                  // 微信基本配置信息
                  wx.config(_config)
                  wx.ready(function() {
                    var shareConfig = {
                      title: shareInfo.title,
                      desc: shareInfo.desc,
                      link: shareInfo.url,
                      imgUrl: shareInfo.image,
                      // title: '壹心理-人生答疑馆',
                      // desc: '心理互助与心理学人交流成长的社区',
                      // link: window.location.href,
                      // imgUrl: 'http://lapp-box5.xinli001.com/images/website-mobile/qa_logo.jpg',
                      success: function(res) {},
                      cancel: function(res) {},
                      fail: function(res) {}
                    }
                    // 分享到朋友圈
                    wx.onMenuShareTimeline(shareConfig)
                    // 分享给朋友
                    wx.onMenuShareAppMessage(shareConfig)
                    // 分享到QQ
                    wx.onMenuShareQQ(shareConfig)
                    // 分享到腾讯微博
                    wx.onMenuShareWeibo(shareConfig)
                    // 分享到QQ空间
                    wx.onMenuShareQZone(shareConfig)
                    wx.updateAppMessageShareData(shareConfig)
                    wx.updateTimelineShareData(shareConfig)
                  })
                })
              }, 500)
            }
          })
      }

      window.addEventListener('scroll', scroll)

      $(document).on('click', '.branch-name, .branch-float .close', function(
        e
      ) {
        branchFloatToggle()
      })

      $('.branch-float .join').on('click', function() {
        let ele = $(this)
        if (ele.attr('hasJoin') === 'true') {
          if (IS_WX) {
            showPlacard()
          } else {
            window.toast('微信打开保存海报~', 3000)
          }
        } else {
          joinBranch({ ele, type: 'float' })
        }
      })

      $('.branch-float .follow').on('click', function() {
        if (!loginJudment(false)) return
        let $this = $(this)
        let id = $this.attr('data-user-id')
        let url = api.followAttention + '?user_id=' + id
        $http
          .get(url, {
            disabledUnLoginInterceptors: true
          })
          .then(res => {
            if (res.data.code === 0) {
              window.toast(res.data.message)
              if (res.data.data.is_follow === 1) {
                $this.text('已关注')
                $this.removeClass('unfollow')
                window.yxl.stat.send({
                  name: '问答-交互行为',
                  properties: {
                    页面: '分馆首页',
                    行为: '点击',
                    对象: '关注',
                    咨询师: $this.attr('data-teacher'),
                    id
                  }
                })
              } else {
                $this.text('关注')
                $this.addClass('unfollow')
              }
            } else {
              window.toast(res.data.message)
            }
          })
          .catch(err => {
            console.error(err)
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: url,
              apiParams: JSON.stringify({
                disabledUnLoginInterceptors: true
              })
            })
          })
      })

      $(document).delegate('.branch-info-more', 'click', function(e) {
        $('.branch-info-toggle').toggle()
      })

      $(document).delegate('.branch-info-toggle', 'click', function(e) {
        e.stopPropagation()
        let _this = $(e.target)
        let className = _this.attr('class')
        switch (className) {
          case 'branch-poster':
            showPlacard()
            break
          case 'branch-desktop':
            window.toast(
              '方法：使用手机浏览器打开此页面，并点击发送至手机桌面。',
              3000
            )
            break
          case 'branch-down':
            // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            //   window.location.href =
            //     'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
            // } else {
            //   window.location.href = `${api.host}/download?utm_source=qaBranch`
            // }
            window.location.href = `${api.host}/download?utm_source=qaBranch`
            break
          case 'branch-follow':
            let link =
              window.baseInfo.account_url ||
              'https://www.xinli001.com/info/100453906'
            if (IS_APP) {
              myBridge.call('openWebView', {
                url: link,
                isCurrentPageOpen: 0
              })
            } else {
              window.open(link)
            }
            break
          case 'branch-admin':
            let href = api.qaBranchAdmin + branchId
            if (IS_APP) {
              myBridge.call('openWebView', {
                url: href,
                isCurrentPageOpen: 0
              })
            } else {
              window.open(href)
            }
            break
          case 'branch-leave':
            showLeaveBranchDialog()
            break
          default:
            break
        }
      })

      $(document).delegate('.write_plan_ul .showReward', 'click', function(e) {
        e.stopPropagation()
        let $this = $(this)
        if ($this.hasClass('active')) {
          showReceiveRewardDialog($this)
        }
      })

      $(document).delegate('.write_plan_ul li', 'click', function(e) {
        let href =
          api.host + '/qa/real_time_topics_detail/' + $(this).attr('topicId')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            hideNavigationBar: 1,
            isCurrentPageOpen: 1
          })
        } else {
          window.location.href = href
        }
      })

      $(document).delegate('.write_plan_ul .join .btn', 'click', function(e) {
        let $this = $(this)
        if ($this.attr('hasJoin')) return

        e.stopPropagation()

        let topicId = $this.parents('li').attr('topicId')
        $http
          .post(api.joinWritingPlan, {
            topic_id: topicId,
            token
          })
          .then(({ data: res }) => {
            if (+res.code === 0) {
              $this.attr('hasJoin', 1)
              $this.text('已参加')

              window.yxl.stat.send({
                name: '问答-交互行为',
                properties: {
                  页面: '分馆首页',
                  行为: '点击',
                  对象: `书写计划-参加`,
                  topicId
                }
              })
            }
            window.toast(res.message)
          })
      })

      function isStudy(params) {
        let { href, isAcademic } = params
        if (IS_APP) {
          if (RegExp(/search-question/).test(href)) {
            myBridge.call('openSearchQuestionPage')
          } else if (isAcademic) {
            myBridge.call('openShareWebView', {
              url: href,
              pageTitle: '壹心理学研会报名表',
              title: '壹心理学研会报名表',
              desc:
                '为了促进心理人的交流，将心理学知识辐射到普通大众中,使心理学的春天提前到来,壹心理正招募「壹心理学研会」成员',
              link: href,
              imgUrl:
                'http://xinli001.mikecrm.com//images/form/wechat_default.jpg'
            })
          } else {
            myBridge.call('openWebView', {
              url: href,
              isCurrentPageOpen: 0
            })
          }
        } else {
          // window.location.href = href;
          window.open(href)
        }
      }

      // 导航栏埋点
      $(document).delegate('.img-content', 'click', function(e) {
        e.preventDefault()
        let $el = $(this),
          href = $el.parent('a').attr('href'),
          isAcademic = false
        window.yxl.stat.send({
          name: '问答-交互行为',
          properties: {
            页面: '分馆首页',
            行为: '点击',
            对象: `顶部导航栏「${$el.attr('keydesc')}」`,
            地址: href
          }
        })

        // 领取补贴
        if (RegExp(/#\/qaReceiveSubsidy/).test(href)) {
          href = href + '?cantonalId=' + branchId
        }

        // 心理小店
        if (RegExp(/#\/qaPsychologicalShop/).test(href)) {
          href = href + '?cantonalId=' + branchId
        }

        isStudy({
          href,
          isAcademic
        })
      })

      // 分管列表
      // $('.go-index').on('click', function(e) {
      //   let href = api.qaBranchList
      //   if (IS_APP) {
      //     myBridge.call('openWebView', {
      //       url: href,
      //       isCurrentPageOpen: 1
      //     })
      //   } else {
      //     window.location.href = href
      //   }
      // })

      // 问答中心/管理
      $('.my-ques').on('click', function(e) {
        e.preventDefault()
        let href = $(this)
          .parent('a')
          .attr('href')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(href)
        }
      })

      // 提问埋点
      $('.aside-tools').on('click', function(e) {
        e.preventDefault()
        let href = $(this)
          .parent('a')
          .attr('href')
        href = href + '&cantonal_id=' + branchId

        // 补全http(s)
        if (!/https?/.test(href)) {
          href = window.location.protocol + href
        }

        window.yxl.stat.send({
          name: '问答-「提问按钮」点击',
          properties: {
            点击位置: '问答主页'
          }
        })
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.location.href = href
        }
      })

      $(document).delegate('.topicItem', 'click', function(event) {
        event.preventDefault()
        let href = $(this)
          .children('a')
          .attr('href')
        directTo(href, 0)
      })

      // 内容点击埋点
      $(document).delegate('.ask-detail', 'click', function(event) {
        event.preventDefault()
        let href = $(this)
          .parent('a')
          .attr('href')
        href = href + '?cantonal_id=' + branchId
        window.yxl.stat.send({
          name: '问答-主页推荐「问题」点击'
        })
        directTo(href, 0)
      })

      // 内容点击埋点
      $(document).delegate('.author-title', 'click', function(event) {
        event.preventDefault()
        let href = $(this)
          .children('a')
          .attr('href')
        href = href + '?cantonal_id=' + branchId
        window.yxl.stat.send({
          name: '问答-主页推荐「问题」点击'
        })
        directTo(href, 0)
      })

      window.onload = function() {
        showSwithFn()
      }

      $('.child_tab button').click(function() {
        let $this = $(this)
        $this
          .addClass('active')
          .siblings()
          .removeClass('active')

        newques_tab_num = $this.index()

        if (newques_tab_num === 2) {
          window.yxl.stat.send({
            name: '问答-交互行为',
            properties: {
              页面: '分馆首页',
              行为: '点击',
              对象: 'tab导航栏-书写计划'
            }
          })
        }

        page = $('.newques .child_tab button')
          .eq(newques_tab_num)
          .attr('page')
        let curList = $('.newques_ul ul').eq(newques_tab_num)
        curList
          .show()
          .siblings()
          .hide()
        showSwithFn()
        let curListLenght = curList.find('li').length

        if (newques_tab_num === 3) {
          // 助人榜单
          window.removeEventListener('scroll', scroll)
          if (page > 1) return
        } else {
          window.addEventListener('scroll', scroll)
        }

        if (curListLenght === 0 && page < 2) {
          $('.branch-title').trigger('click')
        }
      })
    }

    // 加载数据
    qa.loadData = function() {
      $('.branch-title').on('click', function(e) {
        if (e.originalEvent) return
        if (loading) return

        loading = true

        let requestUrl = ''
        let params = { cantonal_id: branchId }
        page = $('.newques .child_tab button')
          .eq(newques_tab_num)
          .attr('page')

        if (newques_tab_num === 0) {
          requestUrl = api.cantonalRecommend
          params.token = token
          params.page = page
          params.size = 5
          params.story_size = 2
        } else if (newques_tab_num === 1) {
          requestUrl = api.getQaData
          params.search_type = 'all'
          params.format = 'json'
          params.tag_name = 'last'
          params.page = page
          params.sshzv = sshzv
        } else if (newques_tab_num === 2) {
          requestUrl = api.writingPlanList
          params.token = token
          params.page = page
          params.size = 10
        } else if (newques_tab_num === 3) {
          // 助人榜单
          requestUrl = api.rankList
          params.token = token
        }

        $('.loading-more').show()

        window.removeEventListener('scroll', scroll)

        $http
          .get(requestUrl, {
            params
          })
          .then(res => {
            res = res.data
            page++

            $('.newques .child_tab button')
              .eq(newques_tab_num)
              .attr('page', page)

            if (
              +res.code !== 0 ||
              (newques_tab_num && res.data == false) ||
              (!newques_tab_num && res.data.question_list == false)
            ) {
              console.error(res.message)
              $('.loading-more').hide()
              window.toast('没有更多数据')
              window.removeEventListener('scroll', scroll)
              loading = false
              return
            } else {
              if (newques_tab_num !== 3) {
                window.addEventListener('scroll', scroll)
              }
            }

            if (newques_tab_num === 0) {
              $('.all_data_ul').append(
                renderQuestionList(res.data, sshzv, true)
              )
            } else if (newques_tab_num === 1) {
              $('.excellent_question_ul').append(
                renderQuestionList(res.data, sshzv)
              )
            } else if (newques_tab_num === 2) {
              $('.write_plan_ul').append(rendRopicList(res.data))
            } else {
              $('.rank_list_ul').html(renderRankList(res.data))
            }

            $('.loading-more').hide()
            loading = false
            showSwithFn()
          })
          .catch(err => {
            loading = false
            $('.loading-more').hide()
            // window.toast(err)
            console.error(err)
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: requestUrl,
              apiParams: JSON.stringify({
                params
              })
            })
          })
      })

      // if (isjoin) {
      //   let initRenderList = $('.all_data_ul li')
      //   if (!initRenderList.length) {
      //     setTimeout(() => {
      //       $('.child_tab button:eq(2)').trigger('click')
      //     })
      //   }
      // }
    }

    return {
      init: qa.init,
      loadData: qa.loadData
    }
  })()

  qa.loadData()
  qa.init()
})()



// WEBPACK FOOTER //
// ./src/pages/ask/askBranch/index.js